import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { apartmentSearchBarData } from './apartment-search-bar.data';
import { SearchPanel } from '../../../components/search-panel/search-panel';
import { LocationDTO } from '@/model/LocationDTO';
import { LocationStatsDTO } from '@/model/LocationStatsDTO';

@Block(apartmentSearchBarData)
@Component({
	components: {
		SearchPanel
	}
})
export class ApartmentSearchBarBlock extends BaseBlock {
	@Prop() locations: LocationDTO[];
	@Prop() locationStats: LocationStatsDTO[];
}

export default ApartmentSearchBarBlock;
